/**
 * @generated SignedSource<<46131e3605a148411e968df92b637737>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserSettingIntegrationsRefetchFragment$variables = {
  id: string;
};
export type UserSettingIntegrationsRefetchFragment$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"UserSettingIntegrationsFragment">;
  };
};
export type UserSettingIntegrationsRefetchFragment = {
  response: UserSettingIntegrationsRefetchFragment$data;
  variables: UserSettingIntegrationsRefetchFragment$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserSettingIntegrationsRefetchFragment",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserSettingIntegrationsFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserSettingIntegrationsRefetchFragment",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isAvailableOnQuantumJobs",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jobBoardProfileLink",
                "storageKey": null
              }
            ],
            "type": "User",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e5b8b48d025755c170441202c5fa37c6",
    "id": null,
    "metadata": {},
    "name": "UserSettingIntegrationsRefetchFragment",
    "operationKind": "query",
    "text": "query UserSettingIntegrationsRefetchFragment(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...UserSettingIntegrationsFragment\n    id\n  }\n}\n\nfragment UserSettingIntegrationsFragment on User {\n  id\n  isAvailableOnQuantumJobs\n  jobBoardProfileLink\n}\n"
  }
};
})();

(node as any).hash = "96827c2d8993955766f617732b6ad3c3";

export default node;
